// extracted by mini-css-extract-plugin
export default {"body":"Dashboard_body__XQE+r","main":"Dashboard_main__hgmZl","grid":"Dashboard_grid__psgVR","card":"Dashboard_card__r5Ziw"};